import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("Logga ut")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_item = _resolveComponent("q-item")!
  const _component_q_list = _resolveComponent("q-list")!
  const _component_q_btn_dropdown = _resolveComponent("q-btn-dropdown")!
  const _directive_close_popup = _resolveDirective("close-popup")!

  return (_openBlock(), _createBlock(_component_q_btn_dropdown, {
    "no-caps": "",
    flat: "",
    label: _ctx.user.Email,
    "content-class": "no-border-radius",
    class: "text-black"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_q_list, { style: {"min-width":"100px"} }, {
        default: _withCtx(() => [
          _withDirectives((_openBlock(), _createBlock(_component_q_item, {
            clickable: "",
            onClick: _ctx.signOut
          }, {
            default: _withCtx(() => [
              _createVNode(_component_q_item_section, { avatar: "" }, {
                default: _withCtx(() => [
                  _createVNode(_component_q_icon, {
                    size: "xs",
                    name: "mdi-logout-variant"
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_q_item_section, null, {
                default: _withCtx(() => [
                  _hoisted_1
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["onClick"])), [
            [_directive_close_popup]
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["label"]))
}